import React, { useState, useEffect, useRef } from "react";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { logOut } from "../../redux/services/authSlice";
import LogoutConfimation from "./LogoutConfimation";
import { useDispatch } from "react-redux";

const Sidebar = ({ isOpen, setSidebarOpen }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const menuItems = [
    { label: "Dashboard", paths: ["/", "/dashboard"] },
    { label: "Classes", paths: ["/classes"] },
    { label: "Contest", paths: ["/contest"] },
    {
      label: "Balance",
      subItems: [
        { label: "Deposit", paths: ["/deposit"] },
        { label: "Withdrawal", paths: ["/withdrawal"] },
        { label: "Transaction", paths: ["/transaction"] },
      ],
    },
    { label: "KYC", paths: ["/kyc"] },
    { label: "QA", paths: ["/qa", "/view-report","/view-result","/view-solution"] },
    { label: "Feedback", paths: ["/feedback"] },
    { label: "Edit profile", paths: ["/edit-profile"] },
    { label: "Change password", paths: ["/change-password"] },
    { label: "Log Out", paths: [""] },
  ];

  const sidebarRef = useRef(null);
  const { pathname } = useLocation();
  const [activeMenu, setActiveMenu] = useState({});
  const [confirm, setConfirm] = useState(false);
  const isSubItemActive = (paths) => {
    return paths.includes(window.location.pathname);
  };
  const toggleDropdown = (path) => {
    setActiveMenu((prev) => ({
      ...prev,
      [path]: !prev[path],
    }));
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        setSidebarOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setSidebarOpen]);
  const handleLinkClick = (e, label, path) => {
    if (label === "Log Out") {
      e.preventDefault();
      setConfirm(true);
    } else {
      setSidebarOpen(false);
    }
  };
  const handleLogout = () => {
    setTimeout(() => {
      navigate("/");
      setConfirm(!confirm);
      dispatch(logOut());
    }, 1000);
  };

  const confirmLogout = () => {
    handleLogout();
    toast("Logout successfully", {
      autoClose: 2000,
      pauseOnHover: false,
    });
  };
  const isMainItemActive = (paths) => paths.includes(pathname);
  return (
    <>
      <aside
        ref={sidebarRef}
        className={`fixed top-0 left-0 z-40 mt-[95px] w-72 bg-white border-r shadow-md transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 transition-transform duration-300 ease-in-out rounded-tr-[22px] rounded-br-[22px] py-2`}
      >
        <div
          className="flex flex-col flex-1 overflow-y-auto custom-scrollbar z-40 
        h-[calc(100vh-250px)] 
        sm:h-[calc(100vh-180px)] 
        md:h-[calc(100vh-130px)]"
        >
          <nav className="ps-4 pe-2">
            <ul className="space-y-1 mb-0">
              {menuItems?.map(({ label, paths = [], subItems = [] }) => (
                <li key={paths[0] || label}>
                  <div>
                    <Link 
                      to={paths[0] || "/"}
                      className={`flex items-center gap-4 px-4 py-3 rounded-lg text-md font-medium transition-colors ${
                        isMainItemActive(paths)
                          ? "bg-[#124699] text-white hover:text-white"
                          : "text-gray-700 hover:text-gray-900 hover:bg-blue-50"
                      }`}
                      onClick={(e) => {
                        if (subItems.length > 0) {
                          toggleDropdown(label);
                          e.preventDefault();
                        } else {
                          handleLinkClick(e, label, paths[0] || "#");
                        }
                      }}
                    >
                      {label}
                      {subItems.length > 0 && activeMenu[label] ? (
                        <IoChevronUp className="w-5 h-5 ml-auto" />
                      ) : (
                        subItems.length > 0 && (
                          <IoChevronDown className="w-5 h-5 ml-auto" />
                        )
                      )}
                    </Link>
                    {subItems.length > 0 && activeMenu[label] && (
                      <ul className="pl-6 space-y-1">
                        {subItems.map(({ label: subLabel, paths = [] }) => (
                          <li key={paths[0] || subLabel}>
                            <Link
                              to={paths[0] || "#"}
                              className={`px-4 py-2 text-gray-700 rounded-lg flex justify-between ${
                                isSubItemActive(paths)
                                  ? "bg-[#124699] text-white hover:text-white"
                                  : "hover:bg-[#e8effa] hover:text-gray-900"
                              }`}
                            >
                               
                              {subLabel} 
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </aside>
      {confirm && (
        <LogoutConfimation
          confirm={confirm}
          onLogout={confirmLogout}
          onCancel={() => setConfirm(!confirm)}
        />
      )}
    </>
  );
};

export default Sidebar;
